import { FunctionComponent, useState } from 'react';
import toInteger from 'lodash/toInteger';
import { useQuery, gql } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Helmet } from 'react-helmet';
import { Profile as ProfileType } from '~types';

import ErrorBoundary from '../error/ErrorBoundary';
import NotFound from '../error/NotFound';
import { Loader } from '~components/Loader';
import { Items, GetTypeSocial } from '~components/profile';

import '../../scss/pages/_profile.scss';
import { ProfileRight } from '~frontend/components/profile/ProfileRight';
import { useHttpClient } from '~shared/frontend/providers/HttpProvider';
import './profile.scss';
import './userStats.scss';
import '../../components/profile/profile-heading/profileHeadStyles.scss';
import Copy from '~frontend/components/header/menu-mob/mobile-menu-modal/copy';
import { Button } from '~shared/frontend/ui/button/button';
import Exit from '~frontend/components/profile/profile-heading/exit';
import Quantity from '../../components/profile/profile-stats/quantity';
import ArrowBottom from '~frontend/components/home/text-dropdown/arrow-bottom';
import ArrowLeft from '~frontend/components/icons/arrow-left';
import { useNavigate } from 'react-router';
import { useProfile } from '~frontend/components/hooks';
import { useUserStats } from '~frontend/components/profile/hooks';

interface GetUser extends ProfileType {
  createdFormat?: any;
}

interface UserData {
  getUser: GetUser;
}

interface UserVars {
  id: number;
}

const User: FunctionComponent = () => {
  const { setHttpContext } = useHttpClient();
  const { id } = useParams();
  const [isStatsVisible, setIsStatsVisible] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getUserStats = useUserStats(+id);

  const userId = toInteger(id);

  const { data, loading, error } = useQuery<UserData, UserVars>(
    gql`
      query User($id: Int!) {
        getUser(id: $id) {
          id
          userName
          userId
          avatar
          social
          createdAt
          createdFormat @client
        }
      }
    `,
    {
      variables: {
        id: userId,
      },
    },
  );

  if (loading) {
    return <Loader />;
  } else if (error) {
    return <>User | Error! {error.message}</>;
  }

  const getUser = data?.getUser;

  if (getUser === null) {
    setHttpContext({ redirect: '/' });
    return <NotFound />;
  }

  const toggleStats = () => {
    setIsStatsVisible(!isStatsVisible);
  };

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>
          {t('Profile userName on Steam and CSCASE', {
            userName: getUser.userName,
          })}
        </title>
        <meta
          name="description"
          content={t(
            'Profile of the user userName on CSCASE, see all openings of cs go cases at userName',
            {
              userName: getUser.userName,
            },
          )}
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="profile">
        <div className="container">
          <div className="profile_header">
            <Button
              text={t('Back')}
              icon={<ArrowLeft />}
              icon_direction="left"
              className={`btn1_dark profile_heading_btn`}
              onClick={handleBackClick}
            />
            <div className="profile_heading_mobile">{t('Profile')}</div>
            <div className="profile_heading_title">{t('Profile')}</div>
          </div>
          <div className="profile_stats">
            {/* <div className="profile_info_mobile">
              <img
                src={getUser.avatar}
                alt="Аватар профиля"
                width={44}
                height={44}
                className="avatar_image"
              />
              <div className="profile_info_mobile_descr">
                <span>{getUser.userName}</span>
                <span className="profile_info_mobile_id">
                  ID {getUser.id} <Copy size={16} color="#47485D" />
                </span>
              </div>
              <div className="profile_info_mobile_exit">
                <Button
                  text=""
                  icon={<Exit />}
                  icon_direction="right"
                  is_icon={true}
                  className="profile_info_mobile_exit"
                />
              </div>
            </div> */}
            <div className="profile_stats_user">
              <div className="profile_info_mobile_descr">
                <span>{getUser.userName}</span>
                <span className="profile_info_mobile_id">
                  ID {getUser.id} <Copy size={16} color="#47485D" />
                </span>
              </div>
            </div>

            <div className="profile_stats_center">
              <div className="avatar_container">
                <img
                  src={getUser.avatar}
                  alt="Аватар профиля"
                  width={140}
                  height={140}
                  className="avatar_image"
                />
              </div>
            </div>

            <div className="profile_stats_right">
              <div
                className={`stats_title ${
                  isStatsVisible ? 'stats_title_active' : ''
                }`}
                onClick={toggleStats}
              >
                <Quantity size={24} />
                <span>{t('acc_stats')}</span>
                <div className="stats_title_arrow">
                  <ArrowBottom />
                </div>
              </div>
              <div
                className={`stats_grid ${
                  isStatsVisible ? 'stats_grid_visible' : ''
                }`}
              >
                <div className="stats_item">
                  <div className="stats_label">{t('Cases')}</div>
                  <div className="stats_value">
                    {getUserStats?.defaultGamesCount} <Quantity size={16} />
                  </div>
                </div>
                <div className="stats_item">
                  <div className="stats_label">{t('Contracts')}</div>
                  <div className="stats_value">
                    {getUserStats?.contractGamesCount}
                    <Quantity size={16} />
                  </div>
                </div>
                <div className="stats_item">
                  <div className="stats_label">{t('Upgrades')}</div>
                  <div className="stats_value">
                    {getUserStats?.upgradeGamesCount}
                    <Quantity size={16} />
                  </div>
                </div>
                <div className="stats_item">
                  <div className="stats_label">{t('on_site')}</div>
                  <div className="stats_value">
                    {getUserStats?.daysOnSite}
                    <Quantity size={16} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="profile_heading_mobile">Предметы</div>
          <div className="profile_heading_title">Предметы</div> */}
          <Items
            //filters={filters}
            isUser={true}
            userId={userId}
          />
        </div>
      </div>
      {/* <div className="profile-page">
        <div className="page-profile page-profile-other">
          <h1 style={{ display: 'none' }}>
            {t('User_h1', {
              userName: getUser.userName,
            })}
          </h1>
          <div className="profile-wrap">
            <div className="profile-center">
              <div className="user-ava">
                <LazyLoadImage src={getUser.avatar} alt={getUser.userName} />
              </div>
              <div className="user-content">
                <div className="user-name">{getUser.userName}</div>
                <div className="user-soc-link">
                  <GetTypeSocial
                    userId={getUser.userId}
                    social={getUser.social}
                    userName={getUser.userName}
                  />
                </div>
              </div>
            </div>

            <ProfileRight userId={userId} isUser={true} />
          </div>
          <div className="profile-cases-wrap">
            <div className="in-case profile-cases profile-cases-user">
              <ErrorBoundary>
                <Items isUser={true} userId={userId} />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default User;
